import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import HERO_BANNER_IMG from "../../assets/images/hero-banner-img.jpg";
import { getPlaylistVideoAPI, VIDEO_API_URL } from "../../constants/util.js";
import { fetchLibraryMainVideo } from "../../api/apiCalls.js";
import { ChatLayout } from "./Chat.jsx";

const categories = [
  "Solar",
  "Panels",
  "Inverters",
  "Battery",
  "Installation",
  "Financing",
  "Warranty",
];

const VideoLibrary = ({ children }) => {
  const [videos, setVideos] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [mainVideoUrl, setMainVideoUrl] = useState(null);

  useEffect(() => {
    fetchVideos();
    //fetchMainVideo();
  }, []);

  const fetchVideos = async () => {
    try {
      const response = await fetch(VIDEO_API_URL, {
        method: "GET",
        headers: { Accept: "application/json" },
      });
      const data = await response.json();
      const uploadPlayListId =
        data?.items[0]?.contentDetails?.relatedPlaylists?.uploads || "";

      if (!uploadPlayListId) {
        return;
      }

      let videosData = [];
      let nextPageToken = "";
      try {
        do {
          const response = await fetch(
            getPlaylistVideoAPI(uploadPlayListId, nextPageToken),
            { method: "GET", headers: { Accept: "application/json" } }
          );

          const data = await response.json();
          if (data.items) {
            videosData = [...videosData, ...data.items];
          }

          nextPageToken = data.nextPageToken || "";
        } while (nextPageToken);
      } catch (error) {}
      setVideos(videosData);
    } catch (error) {}
  };

  const fetchMainVideo = async () => {
    try {
        const res = await fetchLibraryMainVideo('Sample Email.mp4');
        if(res.status===200){
            setMainVideoUrl(res.data)
        }
    } catch {}
}

  // Filter videos based on selected categories and search query
  const filteredVideos = videos?.filter(video => {
    const videoTitle = video?.snippet?.title.toLowerCase();
    const videoDesc = video?.snippet?.description.toLowerCase();

    
    
    const categoryMatch = selectedCategories?.length === 0 ||
        selectedCategories.some(category =>
            videoTitle.includes(category.toLowerCase()) ||
            videoDesc.includes(category.toLowerCase())
        );

    const searchMatch = searchQuery.trim() === "" ||
        videoTitle.includes(searchQuery.toLowerCase()) ||
        videoDesc.includes(searchQuery.toLowerCase());

    return categoryMatch && searchMatch;
});

const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
};

const toggleCategory = (category) => {
    setSelectedCategories((prevSelected) =>
        prevSelected.includes(category)
            ? prevSelected.filter((item) => item !== category)
            : [...prevSelected, category]
    );
};


  return (
    <>
      {/* <Helmet>
        <title>Q/A Video Library</title>
        <meta
          name="description"
          content="Explore our Q/A video library to find answers to your questions about solar energy, battery systems, and more. Learn from our experts through informative videos."
        />
        <meta
          name="keywords"
          content="solar energy, battery systems, solar panels, solar installation, solar maintenance, solar energy benefits, solar energy FAQs"
        />
        <link rel="canonical" href="https://texassolar.pro/video-library" />
      </Helmet> */}
      <div className="video-library">
        <section
          className="hero-section secondary"
          style={{ backgroundImage: `url(${HERO_BANNER_IMG})` }}
        >
          <h3>Q/A Video Library</h3>
        </section>

        <div className="wrapper">
          <div className="main-contents video-library-main-content">
            {children}
            <section className="main-section">
              <ChatLayout />
              <Container maxWidth="xl">
                <div className="cs-content">
                  <Box className="topbar">
                    <Box
                      sx={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
                    >
                      {categories.map((category) => (
                        <Button
                          key={category}
                          onClick={() => toggleCategory(category)}
                          className={`keyword-buttons ${
                            selectedCategories.includes(category)
                              ? "selected-buttons"
                              : ""
                          }`}
                        >
                          {category}
                        </Button>
                      ))}
                    </Box>

                    {/* Search Bar */}
                    <TextField
                      label="Search Videos"
                      variant="outlined"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      className="search-bar"
                    />
                  </Box>

                  {/* Video Grid */}
                  <Grid container spacing={3}>
                    {filteredVideos?.length ? (
                      filteredVideos.map((video) => (
                        <Grid
                          className="video-grid"
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg={4}
                          key={video?.snippet?.resourceId?.videoId}
                        >
                          <Box>
                            <iframe
                              width="100%"
                              height="200"
                              className="video-frame"
                              src={`https://www.youtube.com/embed/${video?.snippet?.resourceId?.videoId}??modestbranding=1&rel=0`}
                              title={video.snippet.title}
                              allowFullScreen
                            ></iframe>
                            <Typography className="video-title">
                              {video.snippet.title}
                            </Typography>
                          </Box>
                        </Grid>
                      ))
                    ) : (
                      <Typography
                        fontSize={26}
                        textAlign="center"
                        mt={5}
                        width={"100%"}
                      >
                        No Videos Found
                      </Typography>
                    )}
                  </Grid>
                </div>
              </Container>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoLibrary;
